import { Box, Button, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import GlobalDialog from "./mui/Dialogue/GlobalDialog";
import { Icon } from "@iconify/react";

const data = [
  { name: "John", age: 30, city: "New York" },
  { name: "Alice", age: 25, city: "London" },
  { name: "Bob", age: 28, city: "Paris" },
];
const CopyDataToSheet = ({ api, loading, data, otherParams, paramsChange }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const newData = data;
  const dispatchDataForExport = paramsChange
    ? { ...otherParams }
    : { ...newData, limit: "no" };
  const copyToClipboard = () => {
    dispatch(api(dispatchDataForExport)).then((res) => {
      if (res.payload.status === "success") {
        if (res.payload.data.length === 0) return;

        // Get headers
        const headers = Object.keys(res.payload.data[0]);

        // Build rows including headers
        const rows = [
          headers.join("\t"), // header row
          ...res.payload.data.map((row) =>
            headers.map((field) => row[field]).join("\t")
          ),
        ];

        // Create the TSV string
        const tsvString = rows.join("\n");

        // Copy to clipboard
        navigator.clipboard
          .writeText(tsvString)
          .then(() => {
            dispatch(api(data)).then((res) => {
              if (res.payload.status === "success") {
                setOpen(false);
              }
            });
            enqueueSnackbar("Data copied to clipboard!", {
              variant: "success",
            });
          })
          .catch((err) =>
            enqueueSnackbar("Failed to copy data to clipboard!", {
              variant: "error",
            })
          );
      } else if (res.payload.status === "failed") {
        enqueueSnackbar(res.payload.message, {
          variant: "error",
        });
      }
    });
  };
  return (
    <GlobalDialog
      title="Export Data"
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"sm"}
      closeButton={true}
      popupButton={
        <Button
          size="small"
          sx={{ borderRadius: 4 }}
          onClick={() => setOpen(true)}
        >
          <Icon
            icon="material-symbols:file-export-outline"
            width="24"
            height="24"
          />
          Export Data
        </Button>
      }
      content={
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            variant="outlined"
            sx={{ borderRadius: 4 }}
            disabled={loading}
            onClick={copyToClipboard}
          >
            {loading && <CircularProgress />}
            {loading ? "Please Wait..." : " Click to copy data"}
          </Button>
        </Box>
      }
    />
  );
};

export default CopyDataToSheet;
